import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_BASE_URL = `${configs.BACKEND_URL}/api/vector-data`;

async function fetchJson(url, options) {
  const response = await fetchWithTenant(url, options);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || data.message || 'Request failed');
  }
  return response.json();
}

export async function getAllVectorData({ page = 1, limit = 50, search = '', type = '' } = {}) {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  if (search) params.append('search', search);
  if (type) params.append('type', type);

  return fetchJson(`${API_BASE_URL}?${params.toString()}`);
}

export async function getVectorData(type, { page = 1, limit = 50, search = '' } = {}) {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  if (search) params.append('search', search);

  return fetchJson(`${API_BASE_URL}/${type}?${params.toString()}`);
}

export async function createVectorData(type, data) {
  return fetchJson(`${API_BASE_URL}/${type}`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateVectorData(type, vectorId, data) {
  return fetchJson(`${API_BASE_URL}/${type}/${vectorId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteVectorData(type, vectorId) {
  return fetchJson(`${API_BASE_URL}/${type}/${vectorId}`, {
    method: 'DELETE',
  });
}

export async function syncUpworkProfile() {
  return fetchJson(`${API_BASE_URL}/sync-profile`, {
    method: 'POST',
  });
}

export async function getSyncStatus() {
  return fetchJson(`${API_BASE_URL}/sync-profile/status`);
}
